// 布置作业
import Vue from 'vue';
import * as TypesHomeworks from '../types/types_homeworks';
// 内容列表，依次是标准教件、知识库、我的题目、上传题目、附件作业
const ContentList = ['standard', 'knowledgeDB', 'favorites', 'upload', 'attachment'];
export default {
    state: {
        lessonInfo: null, // 当前作业对应的课节的信息
        currentContent: '', // 当前展示的内容(题目列表)
        standard: { // 标准教件
            knowledgeId: '' // 知识点id
        },
        knowledgeDB: { // 知识库
            knowledgeIds: [] // 知识点id数组
        },
        favorites: { // 我的题目
            favoritesId: '' // 收藏夹id
        },
        list: [], // 添加到作业中的题目列表
        referList: [], // 引用的作业列表
        selectExamList: {},
        homeworkInfo: null
    },
    mutations: {
        [TypesHomeworks.HOMEWORK_SET_LESSON_INFO](state, payload) {
            state.lessonInfo = payload;
        },
        [TypesHomeworks.HOMEWORK_SET_HOMEWORK_INFO](state, payload) {
            state.homeworkInfo = payload;
        },
        [TypesHomeworks.HOMEWORK_SET_CONTENT](state, {name, data, onlyData}) { // 布置作业左侧sidebar控制右侧展示的内容的通用方法
            /**
             * name:当前展示的内容的名字；
             * data:和内容名同名的对象，用于存放相关数据
             * onlyData: 为true时只更新data不更新展示内容
             * 使用例：
             * store.commit('HOMEWORK_SET_CONTENT', {name: 'standard', data: {knowledgeId:'123abc'}})
             * 将当前展示内容改为standard（标准教件），将data的值赋值给name同名的数据对象
             */
            if (ContentList.includes(name)) {
                if (!onlyData) {
                    state.currentContent = name;
                }
                if (data) {
                    state[name] = data;
                }
            }
        },
        // 添加作业
        [TypesHomeworks.HOMEWORK_ADD_HOMEWORK](state, payload) {
            state.list.push(payload);
        },
        // 移除作业
        [TypesHomeworks.HOMEWORK_REMOVE_HOMEWORK](state, payload) {
            // payload 不存在表示删除的是pdf文件
            if (payload) {
                let index = state.list.findIndex(item => item.id === payload.id);
                state.list.splice(index, 1);
            } else {
                state.list.pop();
            }
        },
        // 批量移除作业
        [TypesHomeworks.HOMEWORK_BATCH_REMOVE](state) {
            state.list = state.list.filter(item => !item.checked);
        },
        // 引用作业
        [TypesHomeworks.HOMEWORK_ADD_REFER](state, payload) {
            state.referList.push(payload);
        },
        // 移除引用
        [TypesHomeworks.HOMEWORK_REMOVE_REFER](state, payload) {
            let index = state.referList.findIndex(item => item === payload);
            state.referList.splice(index, 1);
        },
        // 移动位置
        [TypesHomeworks.HOMEWORK_MOVE_POSITION](state, payload) {
            state.list[payload.index1] = state.list.splice(payload.index2, 1, state.list[payload.index1])[0];
        },
        // 设置作业
        [TypesHomeworks.HOMEWORK_SET_HOMEWORK](state, payload) {
            state.list = payload;
        },
        // 设置筛选条件
        [TypesHomeworks.HOMEWORK_SET_SELECT](state, payload) {
            state.selectExamList = payload;
        },
        // 设置作业列表
        [TypesHomeworks.HOMEWORK_SET_LIST](state, payload) {
            state.list = payload;
        }
    },
    actions: {
    }
};



// WEBPACK FOOTER //
// ./src/views/index/store/modules/modules_homework.js